import {EntityService} from "@/model/service/entity-service"
import {Parcel} from "@/model/entity/parcel/parcel"
import {AxiosPromise} from "axios"
import {Filter} from "@/model/dto/filter"

class ParcelService extends EntityService<Parcel> {
  constructor() {
    super("parcel", Parcel)
  }

  print(parcelIds: number[]) {
    let queryPath = this.path + "/print" + "?"
    parcelIds.forEach(id => (queryPath += "parcelId=" + id + "&"))
    return this.$http({
      method: "get",
      url: queryPath,
      responseType: "arraybuffer"
    })
  }

  deleteParcelsById(parcelIds: number[]) {
    let queryPath = this.path + "/delete_parcels_from_ids" + "?"
    parcelIds.forEach(id => (queryPath += "parcelId=" + id + "&"))
    return this.$http.delete(queryPath)
  }

  cancelParcelsById(parcelIds: number[]) {
    let queryPath = this.path + "/cancel_parcels_from_ids" + "?"
    parcelIds.forEach(id => (queryPath += "parcelId=" + id + "&"))
    return this.$http.delete(queryPath)
  }

  prepareToSend(parcelIds: number[]) {
    let queryPath = this.path + "/prepare_to_send" + "?"
    parcelIds.forEach(id => (queryPath += "parcelId=" + id + "&"))
    return this.$http.get(queryPath)
  }

  createSelfBookingList(parcelIds: number[]) {
    let queryPath = this.path + "/create_self_booking_list" + "?"
    parcelIds.forEach(id => (queryPath += "parcelId=" + id + "&"))
    return this.$http({
      method: "get",
      url: queryPath,
      responseType: "arraybuffer"
    })
  }

  createSelfBookingCodList(parcelIds: number[]) {
    let queryPath = this.path + "/create_self_booking_cod_list" + "?"
    parcelIds.forEach(id => (queryPath += "parcelId=" + id + "&"))
    return this.$http({
      method: "get",
      url: queryPath,
      responseType: "arraybuffer"
    })
  }

  geodataFromShipnotify(shipnotifyId: number) {
    const queryPath = this.path + "/shipnotify/" + shipnotifyId
    return this.$http({
      method: "get",
      url: queryPath,
      responseType: "arraybuffer"
    })
  }

  exportExcel(filters: Filter[]): AxiosPromise<any> {
    return this.$http({
      method: "get",
      url: this.path + "/export/excel" + this.buildQueryParams(filters),
      responseType: "arraybuffer"
    })
  }

  checkZipCodeCountry(entity: Parcel) {
    return this.$http.get(`deliveryAddress/check?zipcode=${entity.shipment.shipmentReceiver.postalCode}&countryCode=${entity.shipment.shipmentReceiver.country.isoCodeAlpha2}&city=${entity.shipment.shipmentReceiver.city}`)
  }
}

export interface IParcelService extends EntityService<Parcel> {
  print(parcelIds: number[]): AxiosPromise

  createSelfBookingList(parcelIds: number[]): AxiosPromise

  createSelfBookingCodList(parcelIds: number[]): AxiosPromise

  deleteParcelsById(parcelIds: number[]): AxiosPromise

  cancelParcelsById(parcelIds: number[]): AxiosPromise

  prepareToSend(parcelIds: number[]): AxiosPromise

  exportExcel(filters: Filter[]): AxiosPromise<any>

  checkZipCodeCountry(entity: Parcel): AxiosPromise
}

const service = new ParcelService()

export const parcelService = service
